<button class="dialog-close" mat-icon-button (click)="onNoClick()">
    <mat-icon>close</mat-icon>
</button>
<hb-save [headline]="resultHeadline" [types]="types" [apiCallStates]="apiCallStates" 
    (apiCallStatesOutput)="apiCallStates = $event" (output)="onNoClick($event)"></hb-save>
